import { useEffect, useRef, useState } from "react";
import { io, Socket } from "socket.io-client";

// Singleton socket instance to prevent multiple connections
let globalSocket: Socket | null = null;
let refCount = 0;

export function useSocket() {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [connected, setConnected] = useState(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    initializedRef.current = true;

    if (!globalSocket) {
      globalSocket = io(window.location.origin, {
        path: "/api/socket.io",
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
      });
    }

    refCount++;
    const s = globalSocket;

    const onConnect = () => {
      setConnected(true);
      console.log("[Socket] Connected:", s.id);
    };

    const onDisconnect = () => {
      setConnected(false);
      console.log("[Socket] Disconnected");
    };

    s.on("connect", onConnect);
    s.on("disconnect", onDisconnect);

    // If already connected, set state immediately
    if (s.connected) {
      setConnected(true);
    }

    setSocket(s);

    return () => {
      s.off("connect", onConnect);
      s.off("disconnect", onDisconnect);
      refCount--;
      if (refCount <= 0 && globalSocket) {
        globalSocket.disconnect();
        globalSocket = null;
        refCount = 0;
      }
    };
  }, []);

  return { socket, connected };
}
